import React from 'react';
import PublicHeader from './PublicHeader';
import { Footer } from './Footer';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div id="public-layout-container" className="flex min-h-screen flex-col">
      <PublicHeader />
      <main id="public-layout-main" className="flex-1 pt-16">{children}</main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
